import { Injectable } from '@angular/core';
import { HttpApiService } from '../base/http-api.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../entities/api-response.model';
import {RawMaterialGroupModel} from '../../entities/raw-material-group.model';

@Injectable({
  providedIn: 'root'
})
export class RawMaterialGroupService {

    constructor(
        public httpApiService: HttpApiService,
    ) {}

    public get(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('raw-material-groups/view', {uid});
    }

    public set(rawMaterialGroupModel: RawMaterialGroupModel): Observable<ApiResponseModel> {
        return this.httpApiService.httpPost('raw-material-groups/store', rawMaterialGroupModel);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('raw-material-groups/destroy', { uid });
    }
}
